// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SOReportAttributes_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /so/report_attributes/remover
 *
 * Removes a service-order report attribute by ID.
 */
import { registerContract } from './validate'

export interface SOReportAttributes_RemoverInput {
id: number
}

registerContract('SOReportAttributes_RemoverInput', {
  id: { type: 'number',  required: true },
})
